export default __webpack_public_path__ + "static/media/audioLetalk.4120ac5a.ogg";